{
  "blog": {
    "title": "Blog",
    "description": "Gérez les articles, catégories et hashtags du blog public de Printway. Planifiez la publication en UTC ; une tâche cron bascule automatiquement Brouillon → Publié le moment venu.",
    "tabsAriaLabel": "Onglets du blog",
    "tabs": {
      "posts": "Articles",
      "categories": "Catégories",
      "hashtags": "Hashtags"
    },
    "columns": {
      "title": "Titre",
      "author": "Auteur",
      "categories": "Catégories",
      "published": "Publié le",
      "scheduled": "Planifié le",
      "updated": "Mis à jour"
    },
    "statusFilter": {
      "all": "Tous"
    },
    "statusLabels": {
      "draft": "Brouillon",
      "scheduled": "Planifié",
      "published": "Publié"
    },
    "posts": {
      "untitled": "(sans titre)",
      "statusFilterLabel": "Filtrer par statut",
      "createLabel": "+ Créer un article",
      "emptyState": "Aucun article — cliquez sur + Créer un article pour en créer un."
    }
  },
  "contact": {
    "title": "Contact",
    "description": "Configurez le formulaire de contact et gérez les soumissions du site public.",
    "tabsAriaLabel": "Onglets",
    "tabs": {
      "config": "Configuration du formulaire",
      "submissions": "Soumissions"
    },
    "fieldTypes": {
      "text": "Texte (une ligne)",
      "multiline": "Multiligne",
      "dropdown": "Liste déroulante",
      "single_choice": "Choix unique",
      "multiple_choice": "Choix multiple"
    },
    "statusLabels": {
      "unread": "Non lu",
      "read": "Lu"
    },
    "toast": {
      "errorTitle": "Erreur"
    },
    "config": {
      "loadError": "Échec du chargement de la configuration",
      "newFieldLabel": "Nouveau champ",
      "saveSuccess": "Configuration du formulaire enregistrée",
      "saveError": "Échec de l'enregistrement",
      "formFieldsHeading": "Champs du formulaire",
      "addFieldButton": "+ Ajouter un champ",
      "loading": "Chargement…",
      "emptyFields": "Aucun champ pour le moment. Cliquez sur « Ajouter un champ » pour commencer.",
      "labelPlaceholder": "Libellé affiché",
      "requiredLabel": "Obligatoire",
      "placeholderPlaceholder": "Placeholder (facultatif)",
      "optionsLabel": "Options (une par ligne)",
      "removeFieldButton": "Supprimer le champ",
      "saving": "Enregistrement…",
      "saveButton": "Enregistrer la configuration"
    },
    "submissions": {
      "noNotificationBanner": "Remarque : le système n'envoie PAS de notification à l'arrivée d'une nouvelle soumission. Les administrateurs doivent consulter cette page régulièrement.",
      "loadError": "Échec du chargement des soumissions",
      "allStatuses": "Tous les statuts",
      "searchPlaceholder": "Rechercher par nom / e-mail",
      "searchButton": "Rechercher",
      "loading": "Chargement…",
      "empty": "Aucune soumission correspondante.",
      "columns": {
        "status": "Statut",
        "name": "Nom",
        "email": "E-mail",
        "created": "Créé le",
        "actions": "Actions"
      },
      "viewButton": "Voir",
      "markReadError": "Échec de la mise à jour",
      "postNoteError": "Échec de l'envoi de la note",
      "noteAdded": "Note ajoutée",
      "detailTitle": "Soumission de {{name}}",
      "responsesHeading": "Réponses",
      "noResponses": "Aucune donnée.",
      "adminNotesHeading_one": "Note admin ({{count}})",
      "adminNotesHeading_other": "Notes admin ({{count}})",
      "noNotes": "Aucune note pour le moment.",
      "adminFallback": "admin",
      "notePlaceholder": "Ajouter une note de réponse…",
      "posting": "Envoi…",
      "addNoteButton": "Ajouter une note",
      "closeButton": "Fermer"
    }
  },
  "ebooks": {
    "title": "Ebooks",
    "description": "Pages de destination de téléchargement PDF (mise en page fixe).",
    "status": {
      "draft": "Brouillon",
      "published": "Publié",
      "archived": "Archivé"
    },
    "actions": {
      "add": "Ajouter un ebook",
      "edit": "Modifier",
      "delete": "Supprimer",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistrement…"
    },
    "filters": {
      "allStatuses": "Tous les statuts",
      "searchPlaceholder": "Rechercher par nom",
      "searchButton": "Rechercher"
    },
    "list": {
      "loading": "Chargement…",
      "empty": "Aucun ebook pour le moment."
    },
    "table": {
      "name": "Nom",
      "description": "Description",
      "status": "Statut",
      "created": "Créé le",
      "creator": "Créateur",
      "downloads": "Téléchargements",
      "url": "URL",
      "actions": "Actions"
    },
    "dialog": {
      "addTitle": "Ajouter un ebook",
      "editTitle": "Modifier l'ebook"
    },
    "form": {
      "name": "Nom",
      "namePlaceholder": "Titre de l'ebook",
      "slug": "Slug",
      "slugPlaceholder": "my-ebook",
      "description": "Description",
      "status": "Statut",
      "contentBlocksTitle": "Blocs de contenu (mise en page fixe)",
      "coverImage": "Image de couverture",
      "coverHelper": "PNG / JPEG ≤ 5 Mo",
      "file": "Fichier (PDF)",
      "fileHelper": "PDF ≤ 25 Mo",
      "introduction": "Introduction",
      "extraBlocks": "Blocs supplémentaires (objet JSON) — avancé",
      "extraPlaceholder": "{\"chapters\": [...]}",
      "publicUrl": "URL publique :"
    },
    "toast": {
      "saved": "Ebook enregistré",
      "deleted": "Supprimé",
      "errorTitle": "Erreur"
    },
    "confirm": {
      "delete": "Supprimer cet ebook ?"
    },
    "errors": {
      "loadFailed": "Échec du chargement des ebooks",
      "saveFailed": "Échec de l'enregistrement",
      "deleteFailed": "Échec de la suppression",
      "formInvalid": "Formulaire invalide",
      "extraJsonNotObject": "extra_json doit être un objet JSON",
      "extraJsonInvalid": "extra_json n'est pas un JSON valide : {{message}}"
    }
  },
  "faq": {
    "title": "FAQ",
    "description": "Gérez les questions fréquentes affichées en accordéon sur la page d'accueil. Glissez-déposez pour réordonner ; modifiez dans une fenêtre modale.",
    "status": {
      "draft": "Brouillon",
      "published": "Publié"
    },
    "actions": {
      "create": "Créer une FAQ",
      "edit": "Modifier",
      "delete": "Supprimer",
      "cancel": "Annuler",
      "close": "Fermer",
      "moveUp": "Monter",
      "moveDown": "Descendre",
      "saving": "Enregistrement…",
      "saveChanges": "Enregistrer les modifications",
      "creating": "Création…",
      "createSubmit": "Créer la FAQ"
    },
    "list": {
      "loading": "Chargement…",
      "empty": "Aucune FAQ pour le moment."
    },
    "table": {
      "order": "Ordre",
      "question": "Question (EN)",
      "category": "Catégorie",
      "status": "Statut",
      "actions": "Actions"
    },
    "modal": {
      "createTitle": "Créer une FAQ",
      "editTitle": "Modifier la FAQ"
    },
    "form": {
      "question": "Question ({{locale}})",
      "answer": "Réponse ({{locale}})",
      "answerPlaceholder": "Réponse détaillée…",
      "category": "Catégorie",
      "categoryPlaceholder": "ex. Billing",
      "sortOrder": "Ordre de tri",
      "status": "Statut"
    },
    "confirm": {
      "delete": "Supprimer cette FAQ ?"
    },
    "errors": {
      "generic": "Erreur",
      "questionRequired": "La question (EN) est obligatoire.",
      "answerRequired": "La réponse (EN) est obligatoire."
    }
  },
  "footer": {
    "title": "Pied de page",
    "description": "Gérer les catégories et les éléments affichés dans le pied de page du site public.",
    "categories": {
      "title": "Catégories",
      "add": "+ Ajouter",
      "loading": "Chargement…",
      "empty": "Aucune catégorie pour le moment."
    },
    "items": {
      "title": "Éléments",
      "add": "+ Ajouter un élément",
      "selectPrompt": "Sélectionnez une catégorie pour voir ses éléments.",
      "loading": "Chargement…",
      "empty": "Aucun élément pour le moment."
    },
    "itemType": {
      "internal_page": "Interne",
      "external_link": "Externe"
    },
    "actions": {
      "edit": "Modifier",
      "delete": "Supprimer",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistrement…"
    },
    "category": {
      "editTitle": "Modifier la catégorie",
      "addTitle": "Ajouter une catégorie",
      "confirmDelete": "Supprimer cette catégorie de pied de page ?"
    },
    "item": {
      "editTitle": "Modifier l'élément",
      "addTitle": "Ajouter un élément",
      "confirmDelete": "Supprimer cet élément de pied de page ?"
    },
    "form": {
      "slug": "Slug",
      "slugPlaceholder": "ex : company",
      "name": "Nom ({{locale}})",
      "description": "Description ({{locale}})",
      "sortOrder": "Ordre de tri",
      "type": "Type",
      "typeInternal": "Page interne",
      "typeExternal": "Lien externe",
      "pageSlug": "Slug de la page",
      "pageSlugPlaceholder": "about-us",
      "fieldTitle": "Titre ({{locale}})",
      "content": "Contenu ({{locale}})",
      "url": "URL",
      "urlPlaceholder": "https://example.com"
    },
    "toast": {
      "errorTitle": "Erreur",
      "categorySaved": "Catégorie enregistrée",
      "itemSaved": "Élément enregistré",
      "deleted": "Supprimé",
      "saveFailed": "Échec de l'enregistrement",
      "deleteFailed": "Échec de la suppression",
      "reorderFailed": "Échec de la réorganisation",
      "loadCategoriesFailed": "Impossible de charger les catégories du pied de page",
      "loadItemsFailed": "Impossible de charger les éléments du pied de page"
    }
  },
  "helpCenter": {
    "breadcrumbHome": "Gestion de la page d'accueil",
    "breadcrumbCurrent": "Centre d'aide",
    "title": "Centre d'aide",
    "description": "Gérer les Sujets → Articles du Centre d'aide (tri par glisser-déposer, i18n EN/VI/FR, aperçu dans un nouvel onglet).",
    "status": {
      "draft": "Brouillon",
      "published": "Publié"
    },
    "topics": {
      "regionLabel": "Sujets d'aide",
      "title": "Sujets",
      "create": "Nouveau sujet",
      "searchLabel": "Rechercher des sujets",
      "searchPlaceholder": "Rechercher par nom…",
      "statusFilterLabel": "Filtrer par statut",
      "allStatuses": "Tous les statuts",
      "colDragHandle": "Poignée de déplacement",
      "colTopic": "Sujet",
      "colArticles": "Articles",
      "colStatus": "Statut",
      "colActions": "Actions",
      "loading": "Chargement…",
      "empty": "Aucun sujet pour le moment. Cliquez sur « Nouveau sujet » pour commencer.",
      "dragToReorder": "Glisser pour réorganiser",
      "untitled": "Sujet sans titre",
      "edit": "Modifier",
      "delete": "Supprimer",
      "preview": "Aperçu"
    },
    "articles": {
      "regionLabel": "Articles",
      "selectPrompt": "Sélectionnez un sujet à gauche pour voir ses articles.",
      "back": "Retour aux Sujets",
      "topicFallback": "Sujet",
      "heading": "{{name}} — Articles",
      "count_one": "{{count}} article",
      "count_other": "{{count}} articles",
      "create": "Nouvel article",
      "colDragHandle": "Poignée de déplacement",
      "colQuestion": "Question",
      "colStatus": "Statut",
      "colSort": "Tri",
      "colActions": "Actions",
      "loading": "Chargement…",
      "empty": "Aucun article dans ce sujet pour le moment.",
      "dragToReorder": "Glisser pour réorganiser",
      "untitled": "Article sans titre",
      "edit": "Modifier",
      "delete": "Supprimer",
      "preview": "Aperçu"
    },
    "toast": {
      "cannotDeleteTopicTitle": "Impossible de supprimer le sujet",
      "cannotDeleteTopicDesc": "Ce sujet contient encore des articles. Supprimez ou réaffectez ses articles avant de supprimer le sujet.",
      "confirmDeleteTopic": "Supprimer le sujet « {{name}} » ?",
      "topicDeleted": "Sujet supprimé.",
      "confirmDeleteArticle": "Supprimer l'article « {{name}} » ?",
      "articleDeleted": "Article supprimé.",
      "loadTopicsFailed": "Impossible de charger la liste des sujets.",
      "loadArticlesFailed": "Impossible de charger les articles.",
      "deleteTopicFailed": "Impossible de supprimer le sujet.",
      "deleteArticleFailed": "Impossible de supprimer l'article.",
      "sortTopicsFailed": "Impossible de trier les sujets.",
      "sortArticlesFailed": "Impossible de trier les articles."
    }
  },
  "homepage": {
    "title": "Page d'accueil",
    "description": "Gérez le contenu de la page d'accueil. Chaque onglet a son propre bouton d'enregistrement — seul l'onglet enregistré envoie un PATCH au serveur.",
    "tablistLabel": "Onglets de la page d'accueil",
    "unsavedConfirm": "L'onglet actuel comporte des modifications non enregistrées. Voulez-vous quitter cet onglet ?",
    "unsavedDot": "Non enregistré",
    "unsavedTitle": "Modifications non enregistrées",
    "tabs": {
      "hero": "Hero",
      "best_selling": "Meilleures ventes",
      "block1": "Bloc 1",
      "block2": "Bloc 2",
      "block3": "Bloc 3",
      "block4": "Bloc 4",
      "banner": "Bannière",
      "email_popup": "Popup e-mail",
      "about_us": "À propos",
      "categories": "Catégories",
      "contact_form": "Formulaire de contact",
      "faq": "FAQ",
      "static_info_2": "Infos statiques 2"
    },
    "common": {
      "saving": "Enregistrement...",
      "saveTab": "Enregistrer {{name}}",
      "add": "+ Ajouter",
      "delete": "Supprimer",
      "unsavedBadge": "Modifications non enregistrées",
      "moveUp": "Déplacer vers le haut",
      "moveDown": "Déplacer vers le bas",
      "linkUrl": "URL du lien"
    },
    "errors": {
      "loadFailed": "Impossible de charger la page d'accueil"
    },
    "footer": {
      "label": "Remarque :",
      "note": "Static Info 1, Fixed Image et l'arrière-plan du Hero sont codés en dur (configuration développeur) selon P8.D-396 — une PR de code est nécessaire pour les modifier."
    },
    "readOnlyAuto": {
      "heading": "Auto-généré",
      "bestSellingNote": "Cet onglet affiche les 5 meilleurs produits des 30 derniers jours, mis à jour automatiquement à partir des commandes.",
      "block3Note": "Cet onglet affiche les 3 produits les plus récents, mis à jour automatiquement.",
      "hardCoded": "(Codé en dur — configuration développeur)"
    },
    "block": {
      "saveError": "Impossible d'enregistrer le bloc",
      "title": "Titre",
      "imageUrl": "URL de l'image"
    },
    "categories": {
      "saveError": "Impossible d'enregistrer les catégories",
      "description": "Liste des catégories/collections affichées sur la page d'accueil. Utilisez les flèches pour réorganiser (le glisser-déposer avec le bundle de catégories arrive en Phase 9).",
      "idPlaceholder": "ID de catégorie"
    },
    "faq": {
      "saveError": "Impossible d'enregistrer la FAQ",
      "description": "Sélectionnez les FAQ publiées (task-33) à afficher sur la page d'accueil. Saisissez un ID de FAQ et cliquez sur Ajouter.",
      "idPlaceholder": "ID FAQ"
    },
    "staticInfo2": {
      "saveError": "Impossible d'enregistrer Static Info 2",
      "description": "Configurez le CTA du bouton Static Info 2. L'arrière-plan + le titre sont codés en dur (configuration développeur).",
      "buttonText": "Texte du bouton ({{locale}})"
    }
  },
  "pages": {
    "title": "Pages personnalisées (Pages)",
    "descriptionBefore": "CRUD des pages statiques personnalisées (à propos, politiques, landing spéciales). Format d'URL ",
    "descriptionAfter": "; le slug partage un espace de noms avec stories/faq/blog/help.",
    "createButton": "Créer une page",
    "genericError": "Erreur",
    "loading": "Chargement…",
    "empty": "Aucune page pour le moment.",
    "edit": "Modifier",
    "delete": "Supprimer",
    "deleteConfirm": "Supprimer cette page ?",
    "columns": {
      "title": "Titre",
      "slug": "Slug",
      "status": "Statut",
      "updated": "Mis à jour",
      "actions": "Actions"
    },
    "status": {
      "draft": "Brouillon",
      "published": "Publié"
    },
    "validation": {
      "titleRequired": "Le titre (EN) est obligatoire.",
      "contentRequired": "Le contenu (EN) est obligatoire."
    },
    "form": {
      "ariaLabel": "Éditeur de page",
      "createTitle": "Créer une page",
      "editTitle": "Modifier la page",
      "backLabel": "Retour à la liste",
      "titleLabel": "Titre ({{locale}})",
      "contentLabel": "Contenu ({{locale}})",
      "contentPlaceholder": "Rédigez le contenu de la page…",
      "slugLabel": "Slug ({{locale}})",
      "slugAutoHint": " (auto depuis le titre si laissé vide)",
      "slugHint": "Doit être unique cross-type avec stories/faq/blog/help. Le BE renvoie 409 SLUG_TAKEN en cas de collision.",
      "statusLabel": "Statut",
      "seoLegend": "SEO ({{locale}})",
      "metaTitle": "Titre Meta",
      "metaDescription": "Description Meta",
      "cancel": "Annuler",
      "saving": "Enregistrement…",
      "saveChanges": "Enregistrer les modifications",
      "creating": "Création…",
      "create": "Créer la page"
    }
  },
  "stories": {
    "errors": {
      "generic": "Erreur"
    },
    "list": {
      "title": "Témoignages de réussite",
      "description": "Affichez la vitrine des réussites des marchands sur la page d'accueil. Glissez-déposez pour réordonner, modifiez par langue et prévisualisez les brouillons avant publication.",
      "create": "Créer une nouvelle histoire",
      "loading": "Chargement…",
      "empty": "Aucune histoire pour le moment.",
      "moveUp": "Déplacer vers le haut",
      "moveDown": "Déplacer vers le bas",
      "edit": "Modifier",
      "delete": "Supprimer",
      "confirmDelete": "Supprimer cette histoire ?",
      "columns": {
        "order": "Ordre",
        "titleMerchant": "Titre / Marchand",
        "status": "Statut",
        "created": "Créé le",
        "actions": "Actions"
      }
    },
    "status": {
      "draft": "Brouillon",
      "published": "Publié"
    },
    "form": {
      "editorAria": "Éditeur d'histoire",
      "editTitle": "Modifier l'histoire",
      "createTitle": "Créer une nouvelle histoire",
      "back": "Retour à la liste",
      "preview": "Aperçu (nouvel onglet)",
      "previewSaveFirst": "Enregistrez l'histoire avant l'aperçu.",
      "cancel": "Annuler",
      "saving": "Enregistrement…",
      "saveChanges": "Enregistrer les modifications",
      "creating": "Création…",
      "createSubmit": "Créer l'histoire",
      "errors": {
        "merchantNameRequired": "Le nom du marchand (EN) est obligatoire.",
        "storyContentRequired": "Le contenu de l'histoire (EN) est obligatoire.",
        "photoUrlRequired": "L'URL de la photo est obligatoire."
      },
      "fields": {
        "photoUrl": "URL de la photo",
        "merchantName": "Nom du marchand",
        "storyContent": "Contenu de l'histoire",
        "contentPlaceholder": "Rédigez le contenu de l'histoire…",
        "metricsHighlight": "Indicateur clé",
        "metricsPlaceholder": "ex. « Hausse de 300 % du chiffre d'affaires »",
        "quote": "Citation",
        "status": "Statut",
        "slug": "Slug",
        "slugPlaceholder": "auto. depuis le nom du marchand (EN)",
        "slugHint": "Le slug partage un espace de noms entre stories/faq/pages/blog/help.",
        "sortOrder": "Ordre de tri"
      },
      "previewClose": "Fermer l'aperçu",
      "previewLabel": "Aperçu ({{locale}})",
      "previewUntitled": "Sans titre"
    }
  },
  "sellerSurvey": {
    "noPermission": "Vous n'avez pas accès à la page Enquête vendeur. Permission requise :",
    "title": "Enquête vendeur",
    "description": "Enquête d'intégration pour les marchands (singleton). L'onglet Config gère les questions et le ciblage ; l'onglet Résultats affiche les réponses soumises et exporte en CSV. L'enquête se trouve actuellement à l'étape 2 de l'intégration marchand.",
    "tablistAria": "Onglets de l'enquête vendeur",
    "tabs": {
      "config": "Config",
      "results": "Résultats"
    },
    "loading": "Chargement…"
  }
}
